// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"419":"8eef7b83","885":"744f6330"}[chunkId] + ".chunk.css";
};